import { useEffect } from "react";
import { useFeatureFlagStore } from "../store/featureFlagStore";
import { useAuthStore } from "../utils/stores/authStore";

/**
 * Hook to fetch and manage feature flags for the authenticated user.
 * Automatically fetches flags on mount if user is authenticated.
 * This is a thin wrapper around the featureFlagStore that handles initialization.
 * :return: Object containing flags Set, loading state, error state, hasFlag checker, and getDisplayMessage
 */
export const useFeatureFlags = () => {
  const initialize = useFeatureFlagStore((state) => state.initialize);
  const flags = useFeatureFlagStore((state) => state.flags);
  const loading = useFeatureFlagStore((state) => state.loading);
  const error = useFeatureFlagStore((state) => state.error);
  const hasFlag = useFeatureFlagStore((state) => state.hasFlag);
  const getDisplayMessage = useFeatureFlagStore(
    (state) => state.getDisplayMessage
  );

  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    // Only initialize feature flags if user is authenticated
    if (user) {
      initialize();
    }
  }, [user, initialize]);

  return { flags, loading, error, hasFlag, getDisplayMessage };
};
